import React from 'react';
import { BiLoaderAlt } from 'react-icons/bi';
import styles from './Loader.module.css';

function Loader() {
  return (
    <div className={styles.block}>
      <BiLoaderAlt className={styles.loader} />
    </div>
  );
}

export default Loader;
